import { Component, EventEmitter, HostListener, Input, Output } from "@angular/core";

/**
 * Panel lateral derecho de filtros secundarios de una tabla.
 *
 * Solo envuelve el markup de `.off-overlay` + `aside.offsidebar-fixed`; los
 * controles se proyectan desde la pagina, asi que el formulario, los
 * valueChanges y la peticion siguen viviendo en el componente que lo usa.
 * Con formularios reactivos se coloca dentro del `<form [formGroup]>` para que
 * `formControlName` resuelva.
 *
 * Uso:
 *   <app-filter-sidebar [open]="openFilters" (closed)="openFilters = false" (cleared)="clearFilters()">
 *     ...controles...
 *   </app-filter-sidebar>
 *
 * Los filtros declarados con `*appFilterItem` se pintan como filas con un check
 * al lado para elegir si tambien se ven en la barra (ver filter-pin.directive).
 */
@Component({
  selector: "app-filter-sidebar",
  templateUrl: "./filter-sidebar.html",
  styleUrls: ["./filter-sidebar.scss"]
})
export class FilterSidebarComponent {
  /** Indica si el panel esta abierto. */
  @Input() open = false;

  /** Se emite al pedir cerrar el panel (X, fondo oscuro o Escape). */
  @Output() closed = new EventEmitter<void>();

  /** Se emite al pulsar "Limpiar filtros"; el boton solo se muestra si hay quien escuche. */
  @Output() cleared = new EventEmitter<void>();

  /**
   * Indica si se debe mostrar el boton de limpiar filtros.
   * @returns `true` si la pagina escucha el evento `cleared`.
   */
  get hasClear(): boolean {
    return this.cleared.observers.length > 0;
  }

  /**
   * Cierra el panel con la tecla Escape cuando esta abierto. Se evita la accion
   * por defecto para que los `input[type=search]` no borren el filtro al cerrar.
   * @param event Evento de teclado.
   * @returns void
   */
  @HostListener("document:keydown.escape", ["$event"])
  onEscape(event: KeyboardEvent): void {
    if (!this.open) return;
    event.preventDefault();
    this.closed.emit();
  }
}
